import React, { useEffect, useRef, useState, useCallback } from 'react';
import { Link } from 'react-router-dom';

const slides = [
  { src: '/hero.png', caption: 'Maxillofacial and Cleft Care', sub: 'Focused care led by Dr. Sangeeta Arvind' },
  { src: '/implant.png', caption: 'Implantology Services', sub: 'Implant-focused consultation and treatment' },
  { src: '/team.png', caption: 'Clinic in Gorakhpur', sub: 'Located near AIIMS Gate No. 4' },
];

function HeroCarousel() {
  const [active, setActive] = useState(0);
  const [dir, setDir]       = useState('next');
  const timer               = useRef(null);

  const go = useCallback((idx, d = 'next') => { setDir(d); setActive(idx); }, []);
  const next = useCallback(() => go((active + 1) % slides.length, 'next'), [active, go]);
  const prev = useCallback(() => go((active - 1 + slides.length) % slides.length, 'prev'), [active, go]);

  useEffect(() => { timer.current = setInterval(next, 4500); return () => clearInterval(timer.current); }, [next]);
  const pause  = () => clearInterval(timer.current);
  const resume = () => { timer.current = setInterval(next, 4500); };

  return (
    <div className="hero-carousel" onMouseEnter={pause} onMouseLeave={resume}>
      <div className="carousel-track">
        {slides.map((s, i) => (
          <div key={i} className={`carousel-slide carousel-slide--dir-${dir}${i === active ? ' carousel-slide--active' : ''}`}>
            <div className="hero-image-frame">
              <img src={s.src} alt={s.caption} className="hero-img" />
              <div className="hero-image-glow" />
              <div className="carousel-caption">
                <span className="carousel-caption-title">{s.caption}</span>
                <span className="carousel-caption-sub">{s.sub}</span>
              </div>
            </div>
          </div>
        ))}
      </div>
      <button className="carousel-arrow carousel-arrow--prev" onClick={prev} aria-label="Previous">
        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5"><path d="M15 18l-6-6 6-6"/></svg>
      </button>
      <button className="carousel-arrow carousel-arrow--next" onClick={next} aria-label="Next">
        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5"><path d="M9 18l6-6-6-6"/></svg>
      </button>
      <div className="carousel-dots">
        {slides.map((_, i) => (
          <button key={i} className={`carousel-dot${i === active ? ' carousel-dot--active' : ''}`}
            onClick={() => go(i, i > active ? 'next' : 'prev')} aria-label={`Slide ${i + 1}`} />
        ))}
      </div>
      <div className="floating-card card-1"><div className="card-icon">😁</div><div><div className="card-title">Painless Treatment</div><div className="card-sub">Advanced anesthesia</div></div></div>
      <div className="floating-card card-2"><div className="card-icon">📍</div><div><div className="card-title">AIIMS Gate No. 4</div><div className="card-sub">Gorakhpur location</div></div></div>
    </div>
  );
}

const highlights = [
  { icon:'🩺', title:'Advanced Cosmetic & Restorative', desc:'From porcelain veneers and teeth whitening to complete smile makeovers — we deliver stunning, natural-looking results.' },
  { icon:'🦷', title:'Dental Implants & Surgery', desc:'All-on-4, All-on-6, Zygomatic and Same-Day Implants with 3D-guided precision for permanent tooth replacement.' },
  { icon:'🤍', title:'Cleft & Maxillofacial Surgery', desc:'Specialised cleft lip/palate repair, TMJ surgery, and jaw fracture treatment by Dr. Sangeeta Arvind.' },
  { icon:'⚡', title:'Laser Dentistry', desc:'Minimally invasive laser treatments for faster healing, less pain, and superior precision across procedures.' },
];

export default function Home() {
  const emRef = useRef(null);
  useEffect(() => {
    document.querySelectorAll('.stat-number').forEach(el => {
      const target = parseInt(el.dataset.target, 10);
      const step = target / (2000 / 16);
      let cur = 0;
      const t = setInterval(() => {
        cur += step;
        if (cur >= target) { cur = target; clearInterval(t); }
        el.textContent = Math.floor(cur).toLocaleString();
      }, 16);
    });
    const el = emRef.current; if (!el) return;
    const words = ['Smile', 'Health', 'Confidence', 'Beauty'];
    let wi = 0, ci = 0, del = false; let tim;
    const type = () => {
      const w = words[wi];
      if (!del) { el.textContent = w.slice(0, ++ci); if (ci === w.length) { del = true; tim = setTimeout(type, 1800); return; } }
      else { el.textContent = w.slice(0, --ci); if (ci === 0) { del = false; wi = (wi + 1) % words.length; } }
      tim = setTimeout(type, del ? 60 : 110);
    };
    tim = setTimeout(type, 1000);
    return () => clearTimeout(tim);
  }, []);

  return (
    <>
      {/* HERO */}
      <section className="hero" id="home">
        <div className="hero-bg-pattern"/>
        <div className="floating-orb orb-1"/><div className="floating-orb orb-2"/><div className="floating-orb orb-3"/>
        <div className="hero-content">
          <div className="hero-text">
            <div className="hero-badge"><span className="badge-dot"/>Best Dental Clinic in Gorakhpur · AIIMS Gate No. 4, Kunraghat</div>
            <h1 className="hero-title">Your Perfect<br/><em ref={emRef}>Smile</em><br/>Starts Here</h1>
            <p className="hero-subtitle">Welcome to Dant Sanjeevani — trusted for expert care and modern facilities. Led by Dr. Sangeeta Arvind (BDS, MDS — Oral & Maxillofacial Surgery), delivering safe, effective, affordable and long-lasting results.</p>
            <div className="hero-cta">
              <Link to="/contact" className="btn-primary">
                <span>Book Appointment</span>
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M5 12h14M12 5l7 7-7 7"/></svg>
              </Link>
              <Link to="/services" className="btn-ghost">
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><circle cx="12" cy="12" r="10"/><polygon points="10 8 16 12 10 16 10 8"/></svg>
                Explore Services
              </Link>
            </div>
            <div className="hero-stats">
              <div className="stat"><span className="stat-number" data-target="14">0</span><span>+</span><span className="stat-label">Treatments</span></div>
              <div className="stat-divider"/>
              <div className="stat"><span className="stat-number" data-target="5000">0</span><span>+</span><span className="stat-label">Happy Patients</span></div>
              <div className="stat-divider"/>
              <div className="stat"><span className="stat-number" data-target="10">0</span><span>+</span><span className="stat-label">Years Experience</span></div>
            </div>
          </div>
          <HeroCarousel />
        </div>
        <div className="scroll-indicator"><div className="scroll-line"/><span>Scroll</span></div>
      </section>

      {/* WHY US */}
      <section className="section why-section">
        <div className="container">
          <div className="section-header reveal">
            <span className="section-tag">Why Dant Sanjeevani?</span>
            <h2 className="section-title">Safe, Effective & <em>Affordable</em> Care</h2>
            <p className="section-desc">Trusted by thousands of patients in Gorakhpur for advanced cosmetic, restorative and surgical dental care with long-lasting results.</p>
          </div>
          <div className="highlights-grid">
            {highlights.map((h, i) => (
              <div key={i} className="highlight-card reveal" style={{'--delay': `${i * 0.1}s`}}>
                <div className="highlight-icon">{h.icon}</div>
                <h3>{h.title}</h3>
                <p>{h.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* QUICK SERVICES PREVIEW */}
      <section className="section" style={{paddingTop:'0'}}>
        <div className="container">
          <div className="section-header reveal">
            <span className="section-tag">What We Offer</span>
            <h2 className="section-title">Specialised <em>Clinical Services</em></h2>
          </div>
          <div className="services-preview-grid">
            {[
              { icon:'🩺', t:'Routine Check-up' }, { icon:'🏆', t:'Dental Implants' },
              { icon:'🤍', t:'Cleft Surgery' }, { icon:'✨', t:'Cosmetic Dentistry' },
              { icon:'⚡', t:'Laser Dentistry' }, { icon:'👑', t:'Crowns & Bridges' },
            ].map((s, i) => (
              <Link to="/services" key={i} className="sprev-card reveal" style={{'--delay': `${i * 0.08}s`}}>
                <span className="sprev-icon">{s.icon}</span>
                <span className="sprev-label">{s.t}</span>
                <span className="sprev-arrow">→</span>
              </Link>
            ))}
          </div>
          <div className="text-center reveal"><Link to="/services" className="btn-ghost" style={{marginTop:'32px'}}>View All Services →</Link></div>
        </div>
      </section>

      {/* PROCESS */}
      <section className="section process-section">
        <div className="container">
          <div className="section-header reveal">
            <span className="section-tag">How It Works</span>
            <h2 className="section-title">Your Path to <em>Consultation</em></h2>
          </div>
          <div className="process-steps">
            {[
              { n:'01', t:'Contact the Clinic', d:'Call or submit your appointment request.' },
              { n:'02', t:'Share Your Concern', d:'Explain whether you need oral surgery, implants, cleft care, or a general consultation.' },
              { n:'03', t:'Confirm the Visit', d:'The clinic confirms a suitable time and visit details.' },
              { n:'04', t:'Attend Consultation', d:'Visit the clinic near AIIMS Gate No. 4 in Gorakhpur.' },
            ].map((s, i) => (
              <React.Fragment key={i}>
                <div className="process-step reveal" style={{'--delay': `${i * 0.15}s`}}>
                  <div className="step-num">{s.n}</div>
                  <div className="step-body"><h3>{s.t}</h3><p>{s.d}</p></div>
                </div>
                {i < 3 && <div className="process-connector"/>}
              </React.Fragment>
            ))}
          </div>
        </div>
      </section>

      {/* CTA BANNER */}
      <section className="section cta-banner reveal">
        <div className="container">
          <div className="cta-inner">
            <div className="cta-text">
              <h2>Ready for Your Best Smile?</h2>
              <p>Book a consultation with Dr. Sangeeta Arvind — safe, effective & affordable dental care in Gorakhpur.</p>
            </div>
            <Link to="/contact" className="btn-primary btn-lg">Book Consultation →</Link>
          </div>
        </div>
      </section>
    </>
  );
}
